(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dh-slides"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('dh-slideshow'))customElements.define('dh-slideshow',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;this.slides=[...this.querySelectorAll('.dh-slide')];this.dots=[...this.querySelectorAll('[data-slide]')];this.i=0;this.slides.forEach((s,i)=>s.inert=i!==0);this.dots.forEach((d,i)=>d.onclick=()=>this.show(i));this.querySelector('.dh-next')?.addEventListener('click',()=>this.show((this.i+1)%this.slides.length));this.querySelector('.dh-pause')?.addEventListener('click',e=>{this.paused=!this.paused;e.currentTarget.textContent=this.paused?'▷':'Ⅱ';e.currentTarget.setAttribute('aria-label',this.paused?'Wznów slajdy':'Wstrzymaj slajdy')});this.addEventListener('shopify:block:select',e=>{this.paused=true;const i=this.slides.findIndex(s=>s===e.target||s.contains(e.target));if(i>=0)this.show(i)});if(this.dataset.autoplay==='true'&&!matchMedia('(prefers-reduced-motion:reduce)').matches)this.timer=setInterval(()=>{if(!this.paused&&!document.hidden&&!this.matches(':hover')&&!this.contains(document.activeElement))this.show((this.i+1)%this.slides.length)},Number(this.dataset.interval)||6000)}show(i){this.i=i;this.slides.forEach((s,n)=>{s.classList.toggle('is-active',n===i);s.setAttribute('aria-hidden',n!==i);s.inert=n!==i});this.dots.forEach((d,n)=>d.setAttribute('aria-pressed',n===i))}disconnectedCallback(){clearInterval(this.timer)}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
